<div class="inicio">

  <div class="div">
    <p class="titulo">SOLICITUDES DE {{tipoSolicitud}}</p>

    <mat-progress-bar *ngIf="cargando" mode="indeterminate"></mat-progress-bar>

    <!--Barra de búsqueda-->
    <div class="grid-container2">
      <mat-form-field>
        <mat-label>BUSCAR</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="INGRESE DATO A BUSCAR">
      </mat-form-field>
    </div>

    <mat-tab-group (selectedIndexChange)="llenarTabla($event)">
      <!--SOLICITUDES PENDIENTES-->
      <mat-tab label="PENDIENTES"></mat-tab>

      <!--SOLICITUDES ATENDIDAS-->
      <mat-tab label="ATENDIDOS"></mat-tab>

      <!--SOLICITUDES CANCELADAS-->
      <mat-tab label="CANCELADOS"></mat-tab>
    </mat-tab-group>

    <div class="div">


      <!--Tabla-->
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="opciones">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
          <td mat-cell *matCellDef="let element">
            <button mat-mini-fab style="background-color: #0804e9;" (click)="detalleSolicitud(element.id_solicitud)">
              <span class="material-icons">visibility</span>
            </button>
            <button mat-mini-fab style="background-color: #fa2424;" *ngIf="statusSolicitud === 'Espera'"
              (click)="rechazarSolicitud(element.id_solicitud)"> <mat-icon>cancel</mat-icon> </button>

          </td>
        </ng-container>
        <ng-container matColumnDef="nomColaborador">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
          <td mat-cell *matCellDef="let element"> {{element.name_colaborador_id}} </td>
        </ng-container>
        <ng-container matColumnDef="nomPuesto">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
          <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}} </td>
        </ng-container>
        <ng-container matColumnDef="name_sucursalCol">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL DEL COLABORADOR </th>
          <td mat-cell *matCellDef="let element"> {{element.name_sucursalCol}} </td>
        </ng-container>
        <ng-container matColumnDef="name_tipo_solicitud">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE SOLICITUD </th>
          <td mat-cell *matCellDef="let element"> {{element.name_tipo_solicitud}} </td>
        </ng-container>
        <ng-container matColumnDef="nomSolicitante">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
          <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
        </ng-container>
        <ng-container matColumnDef="fechaSolicitud">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD </th>
          <td mat-cell *matCellDef="let element"> {{element.fechaSolicitud}} </td>
        </ng-container>
        <ng-container matColumnDef="fechaModificacion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE MODIFICACIÓN </th>
          <td mat-cell *matCellDef="let element"> {{element.fechaModificacion}} </td>
        </ng-container>
        <ng-container matColumnDef="status_solicitud">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS </th>
          <td mat-cell *matCellDef="let element"> {{element.status_solicitud}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
        <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

      </table>
      <mat-paginator #paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]"
        showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>